import axios from 'axios';

const api = axios.create({
  baseURL: "https://city-heart.onrender.com/api",
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ch_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ch_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
